// Style helpers for the Data Recovery TV Board.

export const PRIORITY_STYLES = {
  critical: 'bg-rose-600 text-white border-rose-700',
  high: 'bg-amber-500 text-amber-950 border-amber-600',
  normal: 'bg-sky-700 text-white border-sky-700',
  low: 'bg-slate-600 text-slate-100 border-slate-600',
};

export const PRIORITY_ACCENT = {
  critical: 'border-l-[6px] border-l-rose-500',
  high: 'border-l-[6px] border-l-amber-400',
  normal: 'border-l-[6px] border-l-sky-500',
  low: 'border-l-[6px] border-l-slate-500',
};

export const COLUMN_TONE = {
  pending_diagnostic: {
    header: 'bg-slate-800 text-slate-100',
    accent: 'text-slate-300',
  },
  being_diagnosed: {
    header: 'bg-indigo-800 text-indigo-50',
    accent: 'text-indigo-200',
  },
  image_clone: {
    header: 'bg-cyan-800 text-cyan-50',
    accent: 'text-cyan-200',
  },
  recovery: {
    header: 'bg-blue-800 text-blue-50',
    accent: 'text-blue-200',
  },
  file_verification: {
    header: 'bg-violet-800 text-violet-50',
    accent: 'text-violet-200',
  },
  ready_for_pickup: {
    header: 'bg-emerald-800 text-emerald-50',
    accent: 'text-emerald-200',
  },
  blocked_waiting: {
    header: 'bg-amber-800 text-amber-50',
    accent: 'text-amber-200',
  },
};

export const FLAG_TONE = {
  'Waiting on Customer': 'bg-sky-500/20 text-sky-100 border-sky-400/40',
  'Waiting on Approval': 'bg-yellow-500/20 text-yellow-100 border-yellow-400/40',
  'Parts Received': 'bg-orange-500/20 text-orange-100 border-orange-400/40',
  'Cannot Recover': 'bg-rose-600/30 text-rose-100 border-rose-400/50',
  'Stalled': 'bg-amber-500/25 text-amber-100 border-amber-400/50',
  'Ready but not picked up': 'bg-emerald-500/20 text-emerald-100 border-emerald-400/40',
};

export function flagClass(flag) {
  return FLAG_TONE[flag] || 'bg-slate-500/20 text-slate-100 border-slate-400/40';
}

export function priorityBadgeClass(priority) {
  return PRIORITY_STYLES[priority] || PRIORITY_STYLES.normal;
}

export function priorityAccentClass(priority) {
  return PRIORITY_ACCENT[priority] || PRIORITY_ACCENT.normal;
}

export function columnTone(phase) {
  return COLUMN_TONE[phase] || { header: 'bg-slate-800 text-slate-100', accent: 'text-slate-300' };
}

export function formatAge(hours) {
  if (hours == null || Number.isNaN(hours)) return '—';
  if (hours < 1) {
    const m = Math.max(0, Math.round(hours * 60));
    return `${m}m`;
  }
  if (hours < 24) {
    return `${Math.round(hours)}h`;
  }
  const d = hours / 24;
  if (d < 10) return `${d.toFixed(1)}d`;
  return `${Math.round(d)}d`;
}

export function formatRelative(iso) {
  if (!iso) return '—';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '—';
  const mins = Math.round((Date.now() - t) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
}
